import { HttpContext, HttpParams } from '@angular/common/http';

import {
  isString,
  isBool,
  isObject,
  isArray,
  isEmpty
} from '../helpers';

import {
  ERROR_CALLBACK,
  THROW_ERROR,
  ServerResponse,
  ServerInvalidFormResponse, 
  ServerTextErrorResponse
} from './api.interface';

export type RequestParams = {
  throwError: boolean;
  errorCallback: Function|null;
  cleanParams: boolean;
};

const DEFAULT_PARAMS: RequestParams = {
  throwError: false,
  errorCallback: null,
  cleanParams: false
};
export function buildHttpParams(data: any): HttpParams {
  let params = new HttpParams();

  for(const key in data) {
    let value: any = data[key];

    if(isArray(value)) {
      params = params.delete(key);

      // eslint-disable-next-line no-loop-func
      value.forEach((row: any) => {
        params = params.append(`${key.toString()}[]`, row);
      });
    } else {
      if(isEmpty(value)) {
        continue;
      }

      if(isBool(value)) {
        value = Number(value);
      } else if(isString(value)) {
        value = value.trim();
      }

      params = params.set(key, value);
    }
  }

  return params;
}
export function buildContext(requestParams: Partial<RequestParams>): HttpContext {
  requestParams = {
    ...DEFAULT_PARAMS,
    ...requestParams
  };

  return new HttpContext()
    .set(THROW_ERROR, requestParams.throwError)
    .set(ERROR_CALLBACK, requestParams.errorCallback);
}

export function cleanHttpParams<T = any>(params: T): T {
  const result: T = <T>{};

  for(const key in params) {
    let value: any = params[key];

    if(isEmpty(value)) {
      continue;
    }

    if(isObject(value)) {
      value = cleanHttpParams(value);

      if(0 === Object.keys(value).length) {
        continue;
      }
    }

    result[key] = value;
  }

  return result;
}

export function isServerResponse(body: any): body is ServerResponse {
  if(!isObject(body) || !('data' in body && 'success' in body)) {
    return false;
  }

  return !!body['data'];
}

export function isTextErrorResponse(body: any): body is ServerTextErrorResponse {
  if(!isObject(body) || !('success' in body)) {
    return false;
  }

  return !body['success'] && isString(body['data'].message);
}

export function isInvalidFormResponse(body: any): body is ServerInvalidFormResponse {
  if(!isObject(body) || !('success' in body)) {
    return false;
  }

  return !body['success'] && 'invalidParams' in body['data'];
}

export function isCaptchaResponse(body: any): boolean {
  if(!isObject(body) || !('success' in body)) {
    return false;
  }

  return !body['success'] && 'captcha' in body['data'];
}